import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import colors from '@constants/colors';
import useBottomSheet from '@hooks/ui/useBottomSheet';
import { useMemo } from 'react';

import DropdownArrowIcon from './DropdownArrowIcon';
import styles from './styels.module.scss';

interface Props {
    options?: {value: string, label: string}[];
    placeholder?: string;
    listTitle: string;
    onChange?: (v: string) =>void;
    value?: string;
}

type OptionListProps = Pick<Props, 'options' | 'value' | 'onChange'>;

function Dropdown({
  options, placeholder, listTitle, onChange, value,
}:Props) {
  const displayValue = useMemo<string|undefined>(() => {
    if (value) {
      return options?.find((option) => option.value === value)?.label;
    }
    return undefined;
  }, [options, value]);
  const { openBottomSheet } = useBottomSheet();

  const handleClick = () => {
    openBottomSheet(
      listTitle,
      <OptionList options={options}
                  value={value}
                  onChange={onChange} />,
    );
  };
  return (
        <button className={styles.button}
                onClick={handleClick}
                type='button'>
            {displayValue ? (
                <Text>{displayValue}</Text>
            ) : (
                <Text color={colors.gray5}>
                    {placeholder}
                </Text>
            )}
            <DropdownArrowIcon/>
        </button>
  );
}

function OptionList({ options, value, onChange }:OptionListProps) {
  const { closeBottomSheet } = useBottomSheet();
  return <Column className={styles.list} spacing={18}>
        {options?.map((option) => (
            <Radio key={option.value}
                   isSelected={value === option.value}
                   value={option.value}
                   onChange={() => {
                     onChange?.(option.value);
                     closeBottomSheet();
                   }}>
                {option.label}
            </Radio>
        ))}
    </Column>;
}

export default Dropdown;
